
import { getData, postData, putData } from './redux_data';

import {
    GET_CIERRE_DIARIO, MODIFY_DATOS_CIERRE_DIARIO, UPDATE_DATOS_CIERRE_DIARIO,
    GET_ARTGASTOS, GET_TIPO_GASTOS_CIERRE, GET_OTROS_DATOS_CIERRE_DIARIO, MODIFY_FIELD_OTROSDATOS_CIERRE, NEW_OTROSDATOS, UPDATE_OTROSDATOS_CIERRE, GET_ARTMKT,
    DESBLOQUEAR_CIERRE_DIARIO, CIERRE_DIARIO_CERRAR_DIA,
    GET_RESUMEN_CIERRE_DIARIO
} from '../constants/action_types';

export function getDatosCierreDiario(centroid, date) {
    return getData('cierrediario?centro_id=' + centroid + '&date=' + date, GET_CIERRE_DIARIO);
};

export function modifyDatosCierreDiario(item) {
    return (dispatch, getState) => {
        dispatch({ type: MODIFY_DATOS_CIERRE_DIARIO, payload: item });
    };
};

export function getArtGastosCentro(centroid) {
    return getData('vArtGastos?centro_id=' + centroid, GET_ARTGASTOS);
};

export function getArtMktCentro(centroid) {
    return getData('vArtMKT?centro_id=' + centroid, GET_ARTMKT);
};

export function getTipogastosCierre() {
    return getData('cvtipogastos', GET_TIPO_GASTOS_CIERRE);
};


//otros datos:
export function getOtrosDatosCierreDiario(centroid, date) {
    return getData('cierreDiarioOtrosdatos?centro_id=' + centroid + '&date=' + date, GET_OTROS_DATOS_CIERRE_DIARIO);
};

//update new otrosdatos in DB (post):
export function newOtrosDatosDB(otrosDatos, thenHandler, errorHandler) {
    const postURL = 'dzgenerals';
    return postData(postURL, NEW_OTROSDATOS, otrosDatos, undefined, thenHandler, undefined, errorHandler);
};

export function modifyFieldOtrosDatos(field, value) {
    return dispatch => {
        dispatch({ type: MODIFY_FIELD_OTROSDATOS_CIERRE, payload: { field, value } })
    };
};


//update existing otrosdatos in DB (put):
export function updateOtrosDatosDB(otrosDatos, id, thenHandler, errorHandler) {
    const putURL = 'dzgenerals';
    return putData(putURL, UPDATE_OTROSDATOS_CIERRE, otrosDatos, id, undefined, thenHandler, undefined, errorHandler);

};

export function updateCierreDiarioDatosDB(cierreDiario, centro_id, date, thenHandler) {

    const postURL = `cierreDiario?centro_id=${centro_id}&date=${date}`;

    return postData(postURL, UPDATE_DATOS_CIERRE_DIARIO, cierreDiario, undefined, thenHandler);

};

//get resumen cierre diario
export function getResumenCierreDiario(centroid, date) {
    return getData('cierreDiarioResumen?centro_id=' + centroid + '&date=' + date, GET_RESUMEN_CIERRE_DIARIO);
}

export function unlockCierreDiario(centro_id, date) {

    const postURL = `cierreDiario/DesbloquearCierre?centro_id=${centro_id}&date=${date}`;

    return postData(postURL, DESBLOQUEAR_CIERRE_DIARIO, {}, undefined, undefined);

};

export function cerrarDiaCierreDiario(centro_id, date, thenHandler) {

    return postData(`cierreDiario/CerrarDia?centro_id=${centro_id}&date=${date}`, CIERRE_DIARIO_CERRAR_DIA, {}, undefined, thenHandler);

};